import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSyringe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:#24a81b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(5 5.067)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M13.33,11.013,20.263,4.08",
					transform: "translate(3.887 -2.347)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M22.777,6.6,15.86,13.533",
					transform: "translate(5.573 -0.667)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10.95,5.86,23.117,18.01",
					transform: "translate(2.3 -1.16)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9.083,17.45,3,23.533",
					transform: "translate(-3 6.567)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M7.38,12.35l2.433,2.433",
					transform: "translate(-0.08 3.167)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9.57,10.16,12,12.593",
					transform: "translate(1.38 1.707)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M16.45,3.04l7.583,7.583",
					transform: "translate(5.967 -3.04)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M24.55,14.7,13.655,25.6a3.333,3.333,0,0,1-4.713,0L6.263,22.923a3.333,3.333,0,0,1,0-4.713l10.9-10.895",
					transform: "translate(-1.475 -0.19)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H40V40H0Z"
		})
	]
});
export default SvgSyringe;
